import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook
import image from "../component/login/image11.jpg";
import { Link } from "react-router-dom";
import {
    getAuth,
    createUserWithEmailAndPassword
} from "firebase/auth";
import { getDatabase, ref, set } from "firebase/database";
import { app } from "../firebase";
import "./Signup.css";


const auth = getAuth(app);
const db = getDatabase(app);

const RegistrationForm = ({ theme, toggleTheme }) => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
    });

    // Separate state for email and password
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate(); // Initialize useNavigate hook

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const createuser = () => {
        // Check if the password meets the minimum length requirement
        if (password.length < 8) {
            alert("Password must be at least 8 characters long");
            return;
        }
        // Check if the Confirm Password field matches the Password field
        if (formData.confirmPassword !== password) {
            alert("Passwords do not match!");
            return;
        }
        createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const user = userCredential.user;

                // Save additional user data to the database
                const userId = user.uid;
                const userRef = ref(db, `users/${userId}`);
                set(userRef, {
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    email: email,
                    // You can add more fields here
                });
                console.log("User registered successfully:", user);
                alert("User registered successfully");
                navigate("/home"); // Redirect to the home page
            })
            .catch((error) => {
                console.error("Error registering user:", error.message);
                alert("Error registering user: " + error.message);
            });
    };

    return (
        <div className={`container ${theme}`} style={{ minHeight: '100vh', position: 'relative', overflowY: 'hidden', backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <img
                src={image}
                style={{
                    width: "100%",
                    height: "100%",
                    marginBottom: "-75%",
                    objectFit: "cover",
                }}
                alt="Background"
            />
            <div className="row justify-content-center mt-5">
                <div className="col-md-6 col-lg-4">
                    <div className={`card ${theme === 'dark' ? 'dark-mode' : 'light-mode'}`} style={{ backgroundColor: theme === 'dark' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 0.7)' }}>
                        <div className="card-body">
                            <h2 className={`card-title text-center ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>Register</h2>
                            <form onSubmit={(e) => e.preventDefault()}>
                                <div className="mb-3">
                                    <label htmlFor="firstName" className={`form-label ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>
                                        First Name
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${theme === 'dark' ? 'text-white' : 'text-dark'}`}
                                        id="firstName"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="Write Your First Name here"
                                        style={{ backgroundColor: theme === 'dark' ? 'black' : 'white', color: theme === 'dark' ? 'white' : 'black', '::placeholder': { color: theme === 'dark' ? 'white' : 'black' } }}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="lastName" className={`form-label ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>
                                        Last Name
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${theme === 'dark' ? 'text-white' : 'text-dark'}`}
                                        id="lastName"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="Write Your Last Name here"
                                        style={{ backgroundColor: theme === 'dark' ? 'black' : 'white', color: theme === 'dark' ? 'white' : 'black', '::placeholder': { color: theme === 'dark' ? 'white' : 'black' } }}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="email" className={`form-label ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        className={`form-control ${theme === 'dark' ? 'text-white' : 'text-dark'}`}
                                        id="email"
                                        name="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        placeholder="Write Your Email here"
                                        style={{ backgroundColor: theme === 'dark' ? 'black' : 'white', color: theme === 'dark' ? 'white' : 'black', '::placeholder': { color: theme === 'dark' ? 'white' : 'black' } }}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="password" className={`form-label ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>
                                        Password
                                    </label>
                                    <input
                                        type="password"
                                        className={`form-control ${theme === 'dark' ? 'text-white' : 'text-dark'}`}
                                        id="password"
                                        name="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        placeholder="Write Your Password here"
                                        style={{ backgroundColor: theme === 'dark' ? 'black' : 'white', color: theme === 'dark' ? 'white' : 'black', '::placeholder': { color: theme === 'dark' ? 'white' : 'black' } }}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="confirmPassword" className={`form-label ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>
                                        Confirm Password
                                    </label>
                                    <input
                                        type="password"
                                        className={`form-control ${theme === 'dark' ? 'text-white' : 'text-dark'}`}
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        value={formData.confirmPassword}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="Write Your Password here again for confirmation"
                                        style={{ backgroundColor: theme === 'dark' ? 'black' : 'white', color: theme === 'dark' ? 'white' : 'black', '::placeholder': { color: theme === 'dark' ? 'white' : 'black' } }}
                                    />
                                </div>

                                <button
                                    type="button"
                                    className={`btn btn-block ${theme === 'dark' ? 'btn-light' : 'btn-dark'}`}
                                    onClick={createuser}
                                    style={{ marginLeft: "0%" }}
                                >
                                    Submit
                                </button>
                                <div className={`text-left mt-3 ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>
                                    Already have an account? <Link to="/login" style={{ fontWeight: "bold", textDecoration: "none" }}>Login</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegistrationForm;
